module.exports = __webpack_public_path__ + "static/desktop/img/material-7.5c87b044.jpg";